/* Actions */
import { ACTION_TYPES } from "./actions.js";

const initialState = {
  showNavBar: true,
  showUserMenu: false
};

function navBar(state = initialState, { type, payload }) {
  switch (type) {
    case ACTION_TYPES.SET_SHOW_NAVBAR:
      return { ...state, showNavBar: payload.showNavBar };
    case ACTION_TYPES.TOGGLE_SHOW_USER_MENU:
      return { ...state, showUserMenu: !state.showUserMenu };
    default:
      return state;
  }
}

export default navBar;
